import React from "react";
import { withTranslation } from "react-i18next";
import "rc-time-picker/assets/index.css";
import { Modal, ModalBody, Spinner } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../OfficePolicyManagement.module.scss";
import { usePolicyHistoryById } from "../../../../repositories/office-policy-management-repository";
import { addDefaultStaffCircular, formatCalendarDate } from "../../../../utils";
import constants from "../../../../constants";
function SeeDetailsModal({
  t,
  issaveEmployeeModalOpen,
  setIsSaveEmployeeModalOpen,
  data,
}) {
  const {
    data: historyData,
    isLoading: isHistoryLoading,
    isFetching: isHistoryFetching,
  } = usePolicyHistoryById(data?.id, {
    enabled: !!data?.id,
  });
  const isLoading = isHistoryLoading || isHistoryFetching;
  const heading = {
    Description: { label: t("officePolicyManagement.description"), parsingNeeded: false },
    IsNotifyAllManagementMember: {
      label: t("officePolicyManagement.notifyAllManagementMember"),
      parsingNeeded: false,
    },
    Notes: { label: t("officePolicyManagement.notes"), parsingNeeded: false },
    VersionNumber: { label: t("officePolicyManagement.versionNumber"), parsingNeeded: false },
    PolicyDocumentUrls: { label: t("officePolicyManagement.policyDocumentUrls"), parsingNeeded: true },
    Assignees: { label: t("officePolicyManagement.assignees"), parsingNeeded: true },
    PolicyNotifyManagementMembers: {
      label: t("officePolicyManagement.policyNotifyManagementMembers"),
      parsingNeeded: true,
    },
    Title: { label: t("officePolicyManagement.title"), parsingNeeded: false },
    StartDate: { label: t("officePolicyManagement.startDate"), parsingNeeded: false, dateFormat: true },
    DueDate: { label: t("officePolicyManagement.dueDate"), parsingNeeded: false, dateFormat: true },
    Priority: { label: t("officePolicyManagement.priority"), parsingNeeded: false ,priorityOptions: {
      [constants.addNewPolicyLimits.PRIORITY_LOW]: t("officePolicyManagement.low"),
      [constants.addNewPolicyLimits.PRIORITY_MEDIUM]: t("officePolicyManagement.medium"),
      [constants.addNewPolicyLimits.PRIORITY_HIGH]: t("officePolicyManagement.high"),
    }},
    NotifyAssignees: { label: t("officePolicyManagement.notifyAssignees"), parsingNeeded: false },
    IsNotifyManagement: { label: t("officePolicyManagement.notifyManagement"), parsingNeeded: false },
    RemindAfterPublish: {
      label: t("officePolicyManagement.remindAfterPublishDate"),
      parsingNeeded: false,
    },
    RemindBeforeDueDate: {
      label: t("officePolicyManagement.remindBeforeDueDate"),
      parsingNeeded: false,
    },
  };
  const historyDataStatic = historyData?.data?.changes || [];
  const allMembersAssignees = [
    ...(historyData?.data?.assigneesPrevious || []),
    ...(historyData?.data?.assigneesUpdated || []),
  ].reduce((acc, member) => {
    acc[member.id] = member;
    return acc;
  }, {});
  const allMembersPolicyNotifyManagementMembers = [
    ...(historyData?.data?.policyNotifyManagementMembersPrevious || []),
    ...(historyData?.data?.policyNotifyManagementMembersUpdated || []),
  ].reduce((acc, member) => {
    acc[member.id] = member;
    return acc;
  }, {});
  return (
    <Modal
      isOpen={issaveEmployeeModalOpen}
      toggle={() => setIsSaveEmployeeModalOpen(false)}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={() => setIsSaveEmployeeModalOpen(false)}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody className={styles["add-employee-modal-dialog"]}>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          <span className="modal-title-25">Log Detail</span>
        </Text>
        {/* Log Comparison Table */}
        <div className={styles.logTable}>
          {/* Table Header Row */}
          <div className={`${styles.tableRow} ${styles.tableHeaderRow}`}>
            <div className={styles.cellLabel}></div>
            <div className={styles.columnHeader}>Previous</div>
            <div className={styles.columnHeader}>New</div>
          </div>
          {isLoading && (
            <div style={{ padding: "1rem", textAlign: "center" }}>
              <Spinner
                animation="border"
                size="sm"
                className="loader-spinner"
              />
            </div>
          )}

          {/* Policy Title Row */}
          {historyDataStatic.map((item) => {
            const values = heading[item.fieldName];
            if (!values) return null;
            const { label, parsingNeeded, dateFormat,priorityOptions } =
              heading[item.fieldName];
            const renderAssignees = (
              assignee,
              { assigneesRendering, policyNotifyManagementMembersRendering },
            ) => {
              if (
                assigneesRendering ||
                policyNotifyManagementMembersRendering
              ) {
                if(assignee==="ALL"){
                  return (
                    <div className={styles.assigneeItem}>
                      <span className={styles.assigneeName}>{t("officePolicyManagement.all")}</span>
                    </div>
                  );
                }
                const memberValue = assigneesRendering
                  ? allMembersAssignees[+assignee]
                  : allMembersPolicyNotifyManagementMembers[+assignee];
                if (!memberValue) return null;
                const { name, profilePic } = memberValue;
                return (
                  <div className={styles.assigneeItem}>
                    {name && (
                      <img
                        src={profilePic || "error"}
                        alt={name}
                        onError={addDefaultStaffCircular}
                        className={styles.avatar}
                      />
                    )}
                    <span className={styles.assigneeName}>{name}</span>
                  </div>
                );
              }
              if (
                typeof assignee === "string" ||
                typeof assignee === "number"
              ) {
                return (
                  <div className={styles.assigneeItem}>
                    <span className={styles.assigneeName}>{assignee}</span>
                  </div>
                );
              }
              return null;
            };
            const formatDate = (date) =>
              formatCalendarDate(date, "DD/MM/YYYY");
            const assigneesRendering = item.fieldName === "Assignees";
            const policyNotifyManagementMembersRendering =
              item.fieldName === "PolicyNotifyManagementMembers";
            return (
              <div className={styles.tableRow}>
                <div className={styles.cellLabel}>{label}</div>
                <div className={styles.cellValue}>
                  {parsingNeeded ? (
                    <div className={styles.assigneeList}>
                      {item.previousValue?JSON.parse(item.previousValue).map((values) =>
                        renderAssignees(values, {
                          assigneesRendering,
                          policyNotifyManagementMembersRendering,
                        }),
                      ):"--"}
                    </div>
                  ) : dateFormat ? (
                    formatDate(item.previousValue)
                  ) : (
                    priorityOptions?priorityOptions[item.previousValue] : item.previousValue || "--"
                  )}
                </div>
                <div className={styles.cellValue}>
                  {parsingNeeded ? (
                    <div className={styles.assigneeList}>
                      {item.updatedValue?JSON.parse(item.updatedValue).map((values) =>
                        renderAssignees(values, {
                          assigneesRendering,
                          policyNotifyManagementMembersRendering,
                        }),
                      ):"--"}
                    </div>
                  ) : dateFormat ? (
                    formatDate(item.updatedValue)
                  ) : (
                    priorityOptions?priorityOptions[item.updatedValue] : item.updatedValue || "--"
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100 mt-3"
          title={t("accountOwner.addEmployees")}
          onClick={() => {
            setIsSaveEmployeeModalOpen(false);
          }}
        >
          Close
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(SeeDetailsModal);
